export default __webpack_public_path__ + "assets/99941423ae2eb7c53273fe9c00e5b547.webp";